/*
 * Hall of Heroes procedural content arrays.
 * Moved out of sections/hall-of-heroes.liquid so the template stays under Shopify's 256 KB size limit.
 * Declared at global scope; the Hall of Heroes IIFE reads these via scope-chain lookup.
 */

var HOH_SCENE_WANTS=[
  "to hire the party for a job they shouldn't take",
  "to find the person the party is looking for, before the party does",
  "to ask the party to carry a message nobody else will deliver",
  "to warn the party about something that's already happened",
  "to sell the party something that isn't theirs to sell",
  "to buy something the party doesn't know they have",
  "to challenge one of them to a duel at dawn",
  "to pay back a debt they owe to someone at the table",
  "to collect a debt the party doesn't remember owing",
  "to recruit the party into the war that starts three days after they leave town",
  "to convince the party to leave town before sundown",
  "to be taken somewhere they can't reach alone",
  "to steal something back from the people who stole it first",
  "to deliver a confession before they die",
  "to hide in plain sight for one more night",
  "to meet someone the party is about to meet",
  "to be the last person who ever saw them alive",
  "to apologize for something the party doesn't know happened yet",
  "to ask the party a single question and leave",
  "to offer a trade the party can't refuse",
  "to buy back their own name",
  "to find out if the rumors about one of the party are true",
  "to test whether the party is who they claim to be",
  "to ask the party to bury a body nobody will miss",
  "to pay the party to never tell anyone they met",
  "to bless the party, whether they want it or not",
  "to curse the party, whether they realize it or not",
  "to ask the party to take a child somewhere safe",
  "to ask the party to kill a child nobody else will",
  "to find their own child, who is somewhere in this room",
  "to get one last drink with a stranger before the end",
  "to see if the party remembers them from a life ago",
  "to collect a bounty on someone at the table",
  "to be recognized by the only person left who still calls the old city by its first name",
  "to warn them about the person sitting three tables over",
  "to pass along a key that nobody asked for",
  "to ask the party to walk them home through the woods",
  "to ask the party to read a letter they can't read themselves",
  "to ask the party to witness a contract nobody else will sign",
  "to find out who in the party killed their friend",
  "to thank the party for something they don't remember doing",
  "to beg the party not to take the job they just took",
  "to hire the party to protect them from their own brother",
  "to hire the party to kill their own brother",
  "to offer the party something worth more than gold for something worth nothing",
  "to find out what's under the floorboards of this very tavern",
  "to settle a grudge older than anyone at the table",
  "to trade places with someone for one night",
  "to ask the party to deliver bad news to someone they love",
  "to beg the party to lie for them, just this once",
  "to ask for a story the party has never told anyone",
  "to be told, honestly, whether they should keep going",
  "to get one of the party members drunk enough to confess something",
  "to lose a hand of cards on purpose",
  "to win a hand of cards without cheating",
  "to prove to themselves they can still walk out that door",
  "to be somewhere else without anyone knowing they left",
  "to give away everything in their pack before midnight, including the thing they can't let the party see",
  "to hear their own name spoken out loud one last time",
  "to ask the party to make a choice they themselves can't",
  "to hand the party a key and refuse to say what it opens",
  "to have someone at the table read a letter they can't bring themselves to open",
  "to trade a locket for a story worth the weight",
  "to return a ring that was never given, to someone who never accepted it",
  "to sell a map that's drawn on the back of a confession",
  "to be told what the inscription on the inside of their own wedding band says",
  "to hand off a sealed box with instructions to open it only in a town that doesn't exist yet",
  "to leave behind a coin that keeps turning up in pockets it wasn't in a moment ago",
  "to buy the party a round because they remind them of friends long gone",
  "to tell the story of how they met their wife, and have it land the way they remember it",
  "to return a cloak to someone at the table, who lent it to a stranger at a crossroads four winters ago",
  "to finally thank the party for something nobody else was around to see",
  "to deliver a compliment they've been rehearsing for a month",
  "to be the one who tells the party their brother's still alive",
  "to hand someone at the table the apology their father never got around to giving",
  "to sit with someone at the table in silence, and have it be enough",
  "to prevent a fire that already burned down the inn a year ago",
  "to meet the same party they met yesterday, who looked older and knew their names",
  "to pay off a debt with a coin that's been hot in their hand since they left home three days ago",
  "to warn someone at the table about a choice they're about to make in a week",
  "to buy the same drink they buy every night, even though tonight is the first night anyone's seen them",
  "to hand the party a letter that arrives tomorrow",
  "to find out if the moon rose already tonight, because they don't remember it rising",
  "to finish a conversation they started three years from now",
  "to trade one eye for one memory they don't want anymore",
  "to return a cat they insist they found, which nobody in town owns",
  "to sell a bottled scream for five silver, firm on the price",
  "to be introduced to every dog in the room, one at a time",
  "to have someone at the table explain what a knife is",
  "to apologize to a chair that insulted their mother",
  "to borrow a voice for one sentence, and return it before midnight",
  "to buy a piece of silence, weighed out on a scale the merchant brought themselves",
  "to confess that they're the one who moved the border stone, and watch the party's face when they place it",
  "to admit which of the seven knights they poisoned at dinner last week",
  "to tell someone at the table which of their siblings isn't really their sibling",
  "to name the man they let into the city through the back gate on the night of the fire",
  "to confess that the map the party's been using was drawn by them, wrong on purpose",
  "to give up the location of the grave, in exchange for the party forgetting the name on the stone",
  "to admit they're the only person in the room who remembers what the town used to be called",
  "to confess the name of the god they pray to, and have someone at the table pray with them"
];

var HOH_SCENE_COMPLICATIONS=[
  "someone in the party owes them money, but nobody remembers it",
  "they know something the party is trying to hide",
  "they think one of the party is someone else",
  "they're being followed, and they know it",
  "they're dying, slowly, and haven't told anyone yet",
  "they can't pay, and they know the party knows it",
  "there's a bounty on them, still active, posted by someone at the table",
  "the job they're offering doesn't exist",
  "they've already offered this job to another party, who said no",
  "they've already offered this job to another party, who said yes",
  "they're lying about who sent them",
  "they're lying about who they are",
  "they're telling the truth, and three people in the room have already bet against it",
  "someone at the bar is watching them, and it's not a coincidence",
  "they've been waiting for the party here for three days",
  "they arrived one minute ago and don't know what town this is",
  "they think this is a different year",
  "they think they already had this conversation yesterday",
  "they did have this conversation yesterday, with someone who wasn't here",
  "one of them is wearing something that belongs to one of the party",
  "one of them is wearing something that belonged to a dead friend of the party",
  "they smell like smoke, and there's been no fire in town",
  "they're bleeding, and pretending they aren't",
  "they speak a language nobody at the table should recognize",
  "they speak the common tongue, but badly, like they learned it yesterday",
  "what they want, they could do themselves, if they weren't afraid",
  "what they want, they've already tried to do, and failed",
  "they're sober, and everyone else in the room is not",
  "they're the only one in the room who looks unarmed",
  "they're the only one in the room who looks armed",
  "they have until dawn",
  "they have until the candle on the table burns out",
  "somebody already paid them to have this conversation",
  "somebody paid them more to not have this conversation",
  "they came looking for someone named Hal, and one of the party answered to Hal in another life, and hasn't mentioned it",
  "one of the party walked past them in the street today and didn't recognize them",
  "they know the name of the party's missing member",
  "they know the name of a party member who died a long time ago",
  "they mention a place the party has never been, but dreamt of",
  "they're carrying a letter they haven't read",
  "they've read the letter, and now they can't forget it",
  "the innkeeper is watching the whole conversation",
  "the innkeeper is pretending not to",
  "another party arrives halfway through the conversation, looking for them",
  "the person they want the party to find is already in the room",
  "the person they want the party to find is already dead",
  "they believe the party will say yes, and have already started acting on it",
  "they've written down what happens tonight, in a book in their coat",
  "they're wearing gloves indoors, and the gloves don't fit",
  "they flinch when anyone says the name of the nearest city",
  "they cry when the payment is named, and won't say why",
  "they pull out a coin the party has seen before, on the body of someone else",
  "someone in the party has their face on a poster outside",
  "someone in the party has had this exact dream",
  "what they're carrying is heavier than it should be",
  "what they're carrying is lighter than it should be",
  "they won't sit down",
  "they won't stand up",
  "they aren't who the party is supposed to meet, but the real contact didn't come",
  "they're the real contact, and the party was supposed to not show up",
  "the candle on the table has been burning for an hour, and the wax hasn't dropped",
  "they flinch at sounds nobody else has made yet",
  "their drink has been full for five minutes and they haven't raised the cup",
  "the words on the parchment they're holding are in a language that goes out of style next year",
  "they keep apologizing for something that happens in the next hour",
  "the clock behind the bar is running backwards, and everyone except the party is reading it normally",
  "they answer the question before the party asks it",
  "the ink on the letter they set down isn't dry, but the letter is dated three years ago",
  "their breath fogs the air, and the air in the room is warm",
  "somewhere in this conversation they use the past tense about someone still alive",
  "the letter in their coat is addressed to the party, and unsealed",
  "the coin they paid with is still warm, and the innkeeper puts it in a separate bowl",
  "the cloak they're wearing was peeled off a corpse in the south meadow this morning",
  "their signet ring isn't theirs, and the face on it is still breathing",
  "the dagger at their belt has a notch in the same place as the one at the ranger's hip",
  "the purse on the back of their chair has three times what they paid for, and the bag doesn't clink",
  "there's a key on the table between you that neither party put there",
  "their sleeve is unraveling from a thread that's tied to something under the floor",
  "the seal on the envelope in their pocket is the party's own house seal, pressed this morning",
  "the chain around their neck disappears into their shirt and doesn't end",
  "one of the party has been wearing this person's face for the last ten minutes and hasn't noticed",
  "the stranger's reflection in the window is wearing a different color shirt",
  "they keep calling the cleric by a name the cleric has never heard, and it fits",
  "somebody at the bar is watching, and their face is the party rogue's face from two years ago",
  "the voice coming out of their mouth is not the voice that left their throat",
  "they arrived in town wearing what the party bard had on three nights ago, down to the cloak pin",
  "they've been rehearsing good news in front of the mirror all afternoon, and they can't remember the first line",
  "they bought a round for the whole room an hour ago, and the room forgot to thank them",
  "they're excited to meet the party, and they're about to introduce themselves to the wrong person at the table",
  "they've got a gift for someone here, and they're not sure which of you it's meant for",
  "they came to cry to a stranger, and the party looks too kind for that to go fast",
  "they want to sing the song their grandfather wrote, and they can't remember the second verse",
  "the candle flame is green, and only on every third breath",
  "their shadow is facing the wrong way, and growing more wrong the longer they sit",
  "every time they blink, the sign over the bar changes one letter",
  "the bread on the table is getting warmer, not colder",
  "there's a second heartbeat in the room, and only the party can hear it",
  "they laugh one beat before anyone tells the joke",
  "the door they came in through isn't on that wall anymore",
  "every time somebody says their name out loud, one of the candles goes out"
];

var TAVERN_NAMES=[
  "The Hollow Stump",
  "The Last Candle",
  "The Broken Hourglass",
  "The Salt & Song",
  "The Drowned Lantern",
  "The Copper Stag",
  "The Widow's Rest",
  "The Quiet Fox",
  "The Bent Nail",
  "The Gilded Crow",
  "The Slow Knife",
  "The Ember Door",
  "The Shepherd's Lie",
  "The Third Coin",
  "The Stranger's Coat",
  "The Raven's Promise",
  "The Salt Door",
  "The Lost Half",
  "The Candle That Stayed Lit",
  "The Thorn & Thistle",
  "The Second Watch",
  "The Cellar Oath",
  "The Mourner's Cup",
  "The Crow's Tithe",
  "The Broken Hymn",
  "The Last House",
  "The Quiet Bell",
  "The Unsigned Letter",
  "The Black Lamb",
  "The Forgotten Debt",
  "The Still Water",
  "The Shepherd Without Sheep",
  "The Ashen Hour",
  "The Deaf Judge",
  "The Widower's Toast",
  "The Grey Kettle",
  "The Pale Collar",
  "The Bone Button",
  "The Empty Chair",
  "The Fourth Knock",
  "The Nameless Tide",
  "The Tallow Witness",
  "The Unmade Bed",
  "The Moth's Gallows",
  "The Honest Traitor",
  "The Three-Legged Dog",
  "The Roaring Hearth",
  "The Pig and Pipe",
  "The Green Barrel",
  "The Drunken Miller",
  "The Clatter and Cup",
  "The Fat Cat",
  "The Jolly Thief",
  "The Burnt Potato",
  "The Laughing Priest",
  "The Eight-Legged Table",
  "The Broken Fiddle",
  "The Red Apron",
  "The Sore Loser",
  "The Singing Sow",
  "The Peryton's Feather",
  "The Broken Oath",
  "The Cracked Helm",
  "The Owlbear's Supper",
  "The Paladin's Doubt",
  "The Rogue's Tax",
  "The Beholder's Blind Spot",
  "The Cleric's Ration",
  "The Dire Goose",
  "The Warlock's Reference",
  "The Lantern That Doesn't Light",
  "The Wizard's Regret",
  "The Fey Contract",
  "The Moon Drawer",
  "The Mirror Upstairs",
  "The Seven Saints",
  "The Heretic's Chair",
  "The King's Apology",
  "The Night Mayor's Table",
  "The Quartermaster's Cup"
];

var TAVERN_ATMOSPHERES=[
  "The fire's mostly embers, and nobody's tending it.",
  "Someone has been carving into the same table for three hours.",
  "Half the patrons are looking at the door. The other half are pretending not to.",
  "The floor slopes. Everyone's drink leans the same way.",
  "A bard is sleeping upright at the bar. Has been all night.",
  "The innkeeper won't make eye contact with the stranger in the corner.",
  "Every conversation drops whenever the door opens.",
  "The shutters are nailed from the inside.",
  "A dog under the fire hasn't moved, but it's watching you.",
  "There's a fiddle hanging on the wall that nobody's played in years.",
  "Two candles are out tonight. Neither should be.",
  "The rain stops exactly at the doorway, like it's waiting.",
  "Someone's left a full mug at an empty table. It's still warm.",
  "The sign over the bar is painted over another sign that shows through.",
  "You can hear the kitchen, but nobody's gone in or out since you arrived.",
  "The innkeeper keeps looking at the back door, and not when you'd expect.",
  "Someone burned parchment in the fireplace an hour ago. You can still smell it.",
  "There's a table nobody's sitting at, but three chairs are turned out, ready.",
  "A woman has been stirring the same cup for forty minutes. It's never stopped steaming.",
  "Every time the wind hits the shutters, one of the candles blows out and nobody relights it.",
  "A stain on the floor near the bar has been scrubbed so many times it's shinier than the rest of the boards.",
  "The fiddler keeps starting the same tune and giving up three bars in.",
  "The ceiling beam directly above the long table has a fresh rope mark on it.",
  "A man has been watching the door all night. He hasn't blinked since you sat down.",
  "There's a second set of cutlery at an empty chair at every table.",
  "The innkeeper writes something in a ledger every time the door opens, even though nobody new has come in.",
  "A girl sweeps the same spot by the stairs, and the dust keeps settling back.",
  "Every mug on the bar is turned upside down except one.",
  "The bread on the sideboard has been sitting out for a week and hasn't gone stale.",
  "Four men at a corner table haven't spoken, eaten, or moved in the hour you've been watching.",
  "The air gets colder the closer you get to the hearth.",
  "A painting on the wall is signed with today's date.",
  "There are no mirrors in this place. The spot where one was is cleaner than the wall around it.",
  "The door opens from the outside, and there's nobody there, twice in the hour.",
  "A man at the far table keeps dealing cards to nobody, and nobody corrects him.",
  "The innkeeper pours your drink without looking at you, then stares at your face for a second too long.",
  "Somebody's boots are drying by the fire. They're still wet, and the owner hasn't come back for them.",
  "A wedding party's on their fifth toast. They're getting less coherent.",
  "Three dwarves are arm-wrestling, and a fourth is taking bets with a straight face.",
  "The innkeeper is holding court, and half the room is laughing at something he said ten minutes ago.",
  "A birthday's happening at the long table. The birthday man is losing at cards and winning at joy.",
  "Two old soldiers are showing each other scars, loudly enough that the whole room is pretending to listen to something else.",
  "A card game in the corner is three hands deep and someone's already crying happy tears.",
  "The bard's playing a crowd favorite. Half the room is singing, the other half is making it worse.",
  "A group of farmers have built a fort out of empty mugs, and they keep fortifying it.",
  "Somebody's trying to teach a dog to drink from a cup. The dog is doing great.",
  "A half-orc is reciting poetry, and nobody in the room is tall enough to heckle.",
  "There's a cow in the middle of the floor. Nobody remembers whose cow.",
  "A goblin in a clean apron is earnestly taking orders. Nobody is correcting him.",
  "A parrot at the bar has been heckling the bard for an hour. The bard is winning.",
  "Someone's cast Prestidigitation on the fire. It's pink and smells like oranges.",
  "A monk is teaching the innkeeper's dog to meditate. Both look serious.",
  "A man in full plate armor is asleep at his table. His breathing is the loudest sound in the room.",
  "There's a duck on the counter. Every person in the room is pretending not to see it.",
  "A dwarf has been telling a joke for eleven minutes. Everyone's still waiting.",
  "The innkeeper pours your drink before you ask. She already knew.",
  "The bread's fresh out of the oven, and the butter's still soft enough to spread in one swipe.",
  "A dog with grey on its muzzle puts its head on the nearest lap and stays there.",
  "The innkeeper remembers the party's faces from a decade ago, and none of you have aged as well as she has.",
  "The fire's been tended all night. Someone's making sure you're warm."
];

var TAVERN_SPECIALS=[
  "Venison stew. The innkeeper won't say what kind of venison.",
  "Hard cider, served warm. Three coppers, no questions.",
  "Black bread and a bowl of something that was hot this morning.",
  "Wine that's probably older than anyone in the room.",
  "Hot mulled mead, free refills until midnight. Nobody stays past midnight.",
  "Rabbit pie. The cook is crying.",
  "A stew the locals call \"three days\" for reasons they won't explain.",
  "Ale brewed in the cellar, strong enough that the mug comes with a promise to walk home in pairs.",
  "Mushroom broth. Picked this morning. You shouldn't ask where.",
  "Bread baked in the firepit, two loaves left, one already claimed by a man in the corner.",
  "Fish soup, half price after dusk. There's a reason.",
  "Cheese the innkeeper swears is goat. It's not goat.",
  "Smoked something the cook cuts fresh off what she calls today's road.",
  "Mead with a copper coin at the bottom of the cup. Keep it if you find out why.",
  "Apple wine from a barrel nobody in the kitchen will sign for.",
  "Pork roast. The butcher's been missing since last week, but the meat's fresh.",
  "Pickled turnips from a barrel that won't sit still on the shelf.",
  "A soup the innkeeper only serves to strangers. Nobody in town orders it.",
  "Dark ale with three raisins at the bottom of the mug. Eat the raisins last.",
  "Lamb shank. The cook's apron has more blood on it than one lamb would account for.",
  "Barley bread sliced by whoever's at the bar. The knife passes to the next patron without a word.",
  "A cheese the goat farmer swears she didn't make. Somebody keeps making them.",
  "Stew from yesterday's pot, still simmering. The pot has not been emptied in thirty years.",
  "Pheasant in a sauce the chef invented last night and refuses to describe.",
  "A spirit the innkeeper decants out of sight. Don't ask how old the bottle is.",
  "Dumplings filled with something the kitchen staff won't make eye contact over.",
  "Beef, rare. The cut is from an animal the butcher can't name.",
  "Salt fish served on a plate the innkeeper says belonged to his mother. His mother isn't dead.",
  "A blood pudding the priest of the local temple has been told not to eat.",
  "Roasted roots pulled from a field where last year's crop was burned for reasons nobody discusses.",
  "Sausage that's smoked longer than anyone can remember. The smokehouse is locked from the inside.",
  "Tea brewed from a plant the herbalist found after the last flood. She won't pick it again.",
  "A cold soup the tailor's wife used to make. The tailor's wife is gone.",
  "Dwarven stout so dark you can stand a spoon in it. Two tankards and you're speaking Dwarvish.",
  "Elven spring wine. Pale, cold, older than the winemaker.",
  "Halfling apple pie. There's always one more slice than there was a minute ago.",
  "Hobbit tea. The blend is secret and the cup is too small for a human hand.",
  "Orc blood-grog. The innkeeper only sells it if you ask for it right.",
  "Gnomish honeycakes. Each one contains one tiny surprise the baker swears is edible.",
  "Druid's bread. Made with flour ground on a grindstone a ranger carried here by foot.",
  "Tiefling spiced wine. The first sip is sweet. The second is not.",
  "Drow mushroom stew. The kitchen hand who tends the pot hasn't seen daylight in eight years.",
  "Paladin's ration. Dense bread with a slab of cheese, free for anyone who asks honestly.",
  "Chicken and dumplings. The innkeeper keeps refilling the bowl until you say stop.",
  "Fresh bread from the oven, sliced thick, with butter the farmer brought in this morning.",
  "Hearty beef stew the old cook has been making since his daughter was a child.",
  "A pot of mulled cider, free for anyone who's been on the road longer than three days.",
  "Roast chicken the way your grandmother used to make, if your grandmother was a dwarf.",
  "Ale cold enough to numb your fingers. Good on a day like today.",
  "Lemon cakes the miller's daughter bakes on Sundays. Worth the day you arrived.",
  "A ham the innkeeper smoked himself. He'll tell you the story if you ask.",
  "Honey wine the farmer's wife makes in her spare minutes. It's slow but it's hers.",
  "Hot stew with proper meat and vegetables you can identify. Free bowl for anyone willing to trade a story.",
  "Mead that tastes different to every drinker. The innkeeper finds this very funny.",
  "Bread baked by an earnest goblin. It's surprisingly good, which is the scary part.",
  "A soup the cat insists is hers. The cat is not the cook.",
  "Ale that foams upward. Past your face. Past your hat.",
  "Stew with a bay leaf that keeps appearing no matter how many times the kitchen fishes it out.",
  "A cheese plate that includes one cheese the innkeeper can't identify. He just found it.",
  "Beer from a tap that only works when someone is singing. Nobody's told the kitchen."
];

var TAVERN_RUMORS=[
  "Something's been following the caravans down the west road. Nobody who's seen it has made it back.",
  "The mayor's new advisor doesn't cast a shadow.",
  "A child in the next village started speaking Infernal last week. Only at night.",
  "The old watchtower lights up now. Nobody lives there.",
  "The baker's daughter came home different.",
  "The river's been running warm this whole winter.",
  "Three sheep were found skinned in the south pasture. Nothing was taken.",
  "Somebody keeps leaving fresh flowers on a grave that doesn't have a name.",
  "The bells in the temple rang twice last Sunday. There's only one bell.",
  "A traveler paid for a room last spring with a coin nobody recognizes. It's still in the strongbox.",
  "The wood thrush stopped singing in the eastern groves. Started two months ago.",
  "A hunter came out of the woods wearing his own cloak inside out. Couldn't say why.",
  "The blacksmith's apprentice hasn't slept since the new moon.",
  "Somebody's been buying up every mirror in town. Quietly.",
  "A door opened in the cellar of the manor that never used to be there.",
  "Children in the eastern farms have been drawing the same symbol in the dirt. None of them can tell you what it is.",
  "The priest at the chapel won't enter the confessional booth anymore. He hears voices from the empty side.",
  "A well in the merchant quarter has been filling back up on its own since they covered it.",
  "The new ferryman at the river crossing takes a coin from every passenger. He doesn't give change, and he doesn't speak.",
  "A man who died in the duel last spring was spotted in the market last Thursday, buying carrots.",
  "Hunters have started hearing their own voices from deep in the forest. Their own exact voices.",
  "The carpenter's wife gave birth to a child with her grandfather's scars.",
  "Livestock in the southern fields have been lying down facing north, all of them, every morning at dawn.",
  "A woman has been seen walking out of the lake at dusk. She doesn't come in the day.",
  "The apothecary can't remember selling half of what's missing from his shelves.",
  "Somebody keeps leaving candles at the old crossroads shrine. The shrine hasn't been active for two generations.",
  "A pack of wolves has been seen moving together without making a sound.",
  "The innkeeper at the next town down the road has started locking his doors at noon.",
  "A fisherman pulled a glass bottle from the bay with nothing in it except a folded piece of paper he can't unfold.",
  "The tax collector from the capital hasn't come to collect this quarter. Everyone noticed, nobody's saying.",
  "A man has been seen at the back of the chapel every evening for a month. He doesn't kneel. He doesn't leave with the others.",
  "The farrier's dog started limping on the same leg the blacksmith's apprentice broke last year.",
  "Somebody's been leaving river stones arranged in circles on the graves at the old cemetery.",
  "A boy from the eastern farms hasn't slept in eleven nights. He says he doesn't want to.",
  "The stablemaster counted fourteen horses last night. There are twelve stalls.",
  "The old tower on the hill used to creak in the wind. It's stopped. The wind hasn't.",
  "A merchant's wife opened her pantry yesterday and found a door that wasn't there the day before.",
  "A girl has been waiting at the south road for a week. She says her brother is coming. Her brother has been dead for five years.",
  "The baker's apprentice has been baking bread in loaves of thirteen, and nobody told him to.",
  "Somebody dropped a letter in the well in the square. The water hasn't risen since.",
  "The stonemason can't sleep on his left side anymore. He says the wall he built won't let him.",
  "A woman in the market keeps trying to sell a wedding ring she swears is hers. She isn't married.",
  "The sheep on the western hills won't cross a line that nobody else can see.",
  "The town crier forgot his own name this morning. He remembered it by lunch. He won't say where he was.",
  "A drunk at the back table has been telling the same story for three nights. It's a good story. Nobody believes it.",
  "The old baron's youngest son, long presumed dead, was seen in the river town. He's been asking about his father's estate.",
  "There's a hidden room behind the stables at the abandoned manor. Somebody broke the wall open last month and sealed it back up.",
  "A chest washed up at the river bend last spring. The man who found it hasn't been seen since.",
  "A map was sold at the auction last fall. Nobody's admitted to buying it.",
  "Buried coin under the oak at the crossroads. Everybody knows. Nobody's dug it up.",
  "The late miller left a will nobody can find. His daughter swears it existed.",
  "A cellar under the old chapel has a door nobody's opened in forty years. The key is still on the priest's ring.",
  "The ferryman's grandfather owned the inn across the river. Nobody's been through his papers.",
  "A ship went down in the bay the year of the bad storm. Its hold was never searched. The current's gentle this season.",
  "Somewhere in the walls of the courthouse, the old judge hid something he called 'the settlement.' Nobody's found it.",
  "A merchant died with three rings on his fingers and a fourth in his mouth. The priest pulled it out but won't say what it was.",
  "There's a vault under the granary that doesn't belong to any family in town. The key went missing with the mayor's cousin.",
  "The king's steward hasn't sent a letter to the capital in three weeks. His wife is sending hers through a different courier.",
  "A tax collector went missing on the west road last month. The new one hasn't asked where.",
  "The duchess's new handmaid speaks with an accent from a country that was supposed to have fallen six years ago.",
  "Somebody's been paying the garrison extra, in silver, and the captain isn't reporting it.",
  "The council voted unanimously on the new charter. Every councilman is afraid of a different person.",
  "The heir was supposed to marry the merchant prince's daughter in spring. The engagement was called off. Neither house will say which side ended it.",
  "There are three copies of the treaty. Two are being guarded. The third is somewhere in this town.",
  "The city watch has a new commander. Nobody remembers being told who he was, or who appointed him.",
  "A cousin to the throne has been seen in the city without an escort. He's drinking alone in the cheaper inns.",
  "The crown's agents have started arriving in pairs. They don't stop being a pair, and nobody in the inns knows who they report to.",
  "A wizard has been buying books on Infernal grammar at the capital. He already speaks Infernal fluently.",
  "Every cantrip cast in the town square last Tuesday went off two seconds late. Nobody can explain why.",
  "The wandmaker's apprentice has been replaced. The new one makes better wands. The apprentice is still at the shop.",
  "A divination done at the chapel last week pointed at the mayor's chair. The mayor wasn't in it.",
  "The runes on the old watchtower started glowing last Sunday. Nobody in town remembers who put them there.",
  "A druid left town with a sack of soil and came back a week later without it, or any memory of where he went.",
  "The village dowsers have been finding water in the wrong places. The water is real. The places are impossible.",
  "An alchemist in the merchant quarter has been paying for tears. The going rate is a silver piece, and he's discriminating.",
  "The bounty on the Blackwood highwayman was doubled last week. Two parties have gone after him. Neither's come back.",
  "A beast that killed six in the southern valley has a price on its head. The price keeps going up. Nobody's collected.",
  "The sheriff is quietly looking for someone who can track a ghost. He won't say whose ghost, but he's paying up front.",
  "The caravan guild is offering gold to anyone who can explain why their last three shipments arrived a day early, and short by one crate.",
  "A nobleman is looking for adventurers willing to sign a contract they can't read. The pay is good. The writing is not in any language he recognizes."
];

/* Race/class option lists for the submission form. */
var RACES=['Human','Elf','Dragonborn','Tiefling','Half-Elf','Dwarf','Half-Orc','Halfling','Gnome','Aasimar','Drow','Goliath','Genasi','Tabaxi','Orc','Warforged','Changeling','Goblin','Harengon','Fairy'];
var CLASSES=['Barbarian','Bard','Cleric','Druid','Fighter','Monk','Paladin','Ranger','Rogue','Sorcerer','Warlock','Wizard','Artificer','Blood Hunter'];

/* Rarity ladder data for the tooltip. The Mythic row is hidden — it
 doesn't show a heart range, just a rainbow shimmer. Players discover
 it by hearting characters past 300. */
/* R97: Rebalanced thresholds — wider ranges per tier, mythic moved
   to 1000+. Reflects the new hearts economy where every click counts
   for one full heart (no more tier-factor absorb). */
/* R769 (Jan, 2026-09-17): the ladder moved again. These ranges mirror
   hohGetRarity in hoh-section-core.js (HOH_LEGEND_LOCK_AT 1000,
   HOH_MYTHIC_AT 1200); the Legend Lock at 1,000 is the whole Legendary
   tier now, and the last 200 hearts come only from Explore the Hall. */
var HOH_RARITY_LADDER=[
 {tier:'common',label:'Common',range:'0 to 49 hearts'},
 {tier:'uncommon',label:'Uncommon',range:'50 to 199 hearts'},
 {tier:'rare',label:'Rare',range:'200 to 499 hearts'},
 {tier:'epic',label:'Epic',range:'500 to 999 hearts'},
 {tier:'legendary',label:'Legendary',range:'1,000 to 1,199 hearts'},
 /* R140-Z: Mythic surfaces a real label + threshold instead of the
    previous "???" / "a hidden tier" placeholder. The row still gets
    the .hoh-rarity-tip-row-mythic class via the renderer so the rainbow
    dot + italic name styling carry over. */
 {tier:'mythic',label:'Mythic',range:'1,200+ hearts'}
];

/* Email validator. */
function hohValidEmail(s){
 var v=String(s||'').trim();
 if(!v)return false;
 return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
}

/* Phone normalize to E.164. Prepends +1 for bare 10-digit numbers. */
function hohNormalizePhone(raw){
 if(!raw)return'';
 var cleaned=String(raw).replace(/[^\d+]/g,'');
 if(!cleaned)return'';
 if(cleaned.charAt(0)!=='+'){
 if(cleaned.length===10)cleaned='+1'+cleaned;
 else if(cleaned.length===11&&cleaned.charAt(0)==='1')cleaned='+'+cleaned;
 else cleaned='+'+cleaned;
 }
 return cleaned;
}
/* Strict US/CA NANP validation: +1 then 10 digits, NPA + NXX 2-9. */
function hohValidPhone(raw){
 var n=hohNormalizePhone(raw);
 return /^\+1[2-9]\d{2}[2-9]\d{6}$/.test(n);
}

/* Story quality gate. Heuristics catch placeholder gibberish. */
function hohStoryQuality(text){
 var t=(text||'').trim();
 if(t.length<80){
 return{ok:false,message:'A few more sentences please. The Hall is for heroes with stories worth telling.'};
 }
 var words=t.split(/\s+/).filter(function(w){return w.length>0;});
 if(words.length<12){
 return{ok:false,message:'Add more detail. Aim for a couple of full sentences about who they are and what drives them.'};
 }
 if(/(.)\1{6,}/.test(t)){
 return{ok:false,message:'That looks like placeholder text. The Hall is for heroes with stories worth telling.'};
 }
 if(/(.{2,5})\1{3,}/.test(t)){
 return{ok:false,message:'That looks like placeholder text. The Hall is for heroes with stories worth telling.'};
 }
 var unique={};
 words.forEach(function(w){unique[w.toLowerCase()]=true;});
 if(words.length>=12&&Object.keys(unique).length/words.length<0.4){
 return{ok:false,message:'Add more variety. The story should describe who they are, what drives them, what they have survived.'};
 }
 var letters=t.replace(/[^a-zA-Z]/g,'').toLowerCase();
 if(letters.length<60){
 return{ok:false,message:'Tell us more, in real words. The Hall is for heroes with stories worth telling.'};
 }
 var vowelCount=(letters.match(/[aeiou]/g)||[]).length;
 var vowelRatio=vowelCount/letters.length;
 if(vowelRatio<0.20||vowelRatio>0.55){
 return{ok:false,message:'That does not look like a real story. Try again with words that bring your hero to life.'};
 }
 return{ok:true};
}
/* Secondary, softer gate. A story can clear hohStoryQuality (real words, not
   gibberish) and still be a one-liner that the Hall should not feature publicly.
   This does NOT block the submit. The caller submits the hero but flags it
   is_hidden so it lands in the keeper's approval pool, reachable only by its
   direct link until approved. "Moderate" bar: a real short paragraph passes; a
   single short line does not. Returns {hide:boolean, reason:string}. */
function hohStoryAutoHide(text){
 var t=(text||'').trim();
 if(!t) return {hide:true,reason:'empty'};
 var words=t.split(/\s+/).filter(function(w){return w.length>0;});
 var wc=words.length;
 var chars=t.length;
 /* Sentence segments that carry real weight: split on . ! ? and keep only
    segments with at least three words, so "Hi." or a trailing "..." do not
    inflate the count. */
 var sentences=t.split(/[.!?]+/).map(function(s){return s.trim();})
   .filter(function(s){return s && s.split(/\s+/).filter(function(w){return w.length>0;}).length>=3;}).length;
 if(chars<200) return {hide:true,reason:'short'};
 if(wc<35) return {hide:true,reason:'fewwords'};
 if(sentences<2) return {hide:true,reason:'oneliner'};
 return {hide:false,reason:''};
}
if(typeof window!=='undefined'){ window.hohStoryAutoHide=hohStoryAutoHide; }

/* ============================================================
   R793 · THE HALL'S OWN DOORS (favourites, daily tickets, Explore)
   ============================================================
   Jan, 2026-09-22: hearts become a personal favourite (one per account
   and hero, no counts), each of your own heroes takes one raffle ticket
   a day from its own page in the main Hall, and Explore the Hall is a
   main-Hall event of 20 heroes you have never seen.

   Six SECURITY DEFINER doors carry it (sql R793B), every one checked
   with the account's email and PIN and keyed on email_hash server side:
     hoh_hall_heart_set(p_email,p_pin,p_character_id,p_on) -> {ok,hearted}
     hoh_hall_hearts_list(p_email,p_pin)                    -> {ok,ids}
     hoh_hall_ticket_apply(p_email,p_pin,p_character_id)    -> {ok,reason?,tickets,pool,chance,applied_today,next_at}
     hoh_hall_ticket_state(p_email,p_pin)                   -> {ok,pool,day,next_at,heroes:[{id,tickets,applied_today}]}
     hoh_hall_explore_state(p_email,p_pin)                  -> {ok,seen,today,limit,done_today,entry_granted_today}
     hoh_hall_explore_mark(p_email,p_pin,p_character_id)    -> {ok,today,done_today,entry_granted}

   ⛔ THE THEME SHIPS BEFORE THE SQL. Until R793B is installed every door
   answers PostgREST's schema-cache miss (PGRST202). That one answer puts
   the whole page in LEGACY mode, which is exactly today's Hall: hearts,
   tickets and Explore behave as they do now. The first real answer from
   any door (data, a refusal, or a permission error) proves the doors
   exist and flips the page to LIVE. A network failure proves nothing and
   changes nothing. The browser never counts anything itself: every
   number shown in live mode is the one the door returned.

   The mode is remembered per device (live for a day, legacy for ten
   minutes) so a returning visitor paints the right Hall before the first
   answer lands, and the section's pre-paint script reads the same key.

   Public: window.HOHHallDoors and window.hohR793Live().
   Events on document: hoh:r793-mode, hoh:favourites-changed,
   hoh:hall-tickets-changed, hoh:explore-state. */
(function(){
  'use strict';
  if(typeof window === 'undefined' || window.HOHHallDoors) return;
  var MODE_KEY = 'hoh-r793-mode';
  var LIVE_TTL = 24 * 3600 * 1000;
  var LEGACY_TTL = 10 * 60 * 1000;
  var mode = 'unknown';
  function readModeCache(){
    try {
      var raw = JSON.parse(localStorage.getItem(MODE_KEY) || 'null');
      if(raw && (raw.mode === 'live' || raw.mode === 'legacy') && raw.at){
        var age = Date.now() - raw.at;
        if(age >= 0 && age < (raw.mode === 'live' ? LIVE_TTL : LEGACY_TTL)) return raw.mode;
      }
    } catch(_){}
    return 'unknown';
  }
  mode = readModeCache();

  function emit(name, detail){
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch(_){}
  }
  function paintModeClass(){
    try {
      var html = document.documentElement;
      if(!html) return;
      html.classList.toggle('hoh-r793-live', mode === 'live');
      html.classList.toggle('hoh-r793-legacy', mode === 'legacy');
    } catch(_){}
  }
  function setMode(next){
    if(next !== 'live' && next !== 'legacy') return;
    try { localStorage.setItem(MODE_KEY, JSON.stringify({ mode: next, at: Date.now() })); } catch(_){}
    if(next === mode) return;
    var from = mode;
    mode = next;
    paintModeClass();
    /* `from` lets listeners skip work: unknown already paints the legacy
       Hall, so unknown -> legacy changes nothing on screen */
    emit('hoh:r793-mode', { mode: mode, from: from });
  }
  paintModeClass();

  /* ---------- account ---------- */
  function readToken(){
    try {
      var t = JSON.parse(localStorage.getItem('hoh-your-hall-token') || 'null');
      return (t && typeof t === 'object') ? t : null;
    } catch(_){ return null; }
  }
  function creds(){
    var email = '';
    try { if(typeof window.hohYourHallEmail === 'function') email = window.hohYourHallEmail() || ''; } catch(_){}
    var t = readToken();
    if(!email && t && t.email) email = t.email;
    email = String(email || '').trim().toLowerCase();
    var pin = (t && t.pin) ? String(t.pin) : '';
    return { email: email, pin: pin, ok: !!(email && pin) };
  }
  function accountKey(){ return creds().email || 'guest'; }

  /* ---------- the Pacific day (tickets and Explore turn at midnight PT) ---------- */
  function ptDay(d){
    d = d || new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d);
      var y = '', m = '', dd = '';
      parts.forEach(function(p){ if(p.type === 'year') y = p.value; else if(p.type === 'month') m = p.value; else if(p.type === 'day') dd = p.value; });
      if(y && m && dd) return y + '-' + m + '-' + dd;
    } catch(_){}
    /* No Intl time zones: Pacific is UTC-8 in winter and UTC-7 in summer.
       Taking 8 hours is at most an hour early for a cache key, and the
       server's own day is the one that counts. */
    return new Date(d.getTime() - 8 * 3600 * 1000).toISOString().slice(0, 10);
  }

  /* ---------- the client ---------- */
  function client(){
    var c = window.hohSupabaseClient;
    return (c && typeof c.rpc === 'function') ? c : null;
  }
  function waitClient(ms){
    var c = client();
    if(c) return Promise.resolve(c);
    return new Promise(function(resolve){
      var waited = 0;
      var iv = setInterval(function(){
        waited += 120;
        var cc = client();
        if(cc || waited >= ms){ clearInterval(iv); resolve(cc || null); }
      }, 120);
    });
  }
  /* The same test hoh-contract-data.js uses: a schema-cache miss must name
     THIS function and say it was not found. A 42883 counts only when the
     primary message says this exact function does not exist, because an
     installed door calling a missing helper also answers 42883. */
  function isMissing(err, fn){
    if(!err) return false;
    var code = String(err.code || '').toUpperCase();
    var safe = String(fn).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if(code === 'PGRST202'){
      var text = [err.message, err.details, err.hint].join(' ');
      return new RegExp('(?:^|[^a-z0-9_])(?:public\\.)?' + safe + '(?:[^a-z0-9_]|$)', 'i').test(text) && /could not find|schema cache/i.test(text);
    }
    if(code === '42883'){
      return new RegExp('\\bfunction\\s+(?:(?:"?public"?)\\.)?"?' + safe + '"?(?:\\s*\\([^\\n]{0,512}\\))?\\s+does not exist\\b', 'i').test(String(err.message || ''));
    }
    return false;
  }
  /* One call, one plain result: {ok, data, reason, missing, network}. */
  function call(fn, args){
    return waitClient(8000).then(function(c){
      if(!c) return { ok: false, reason: 'still_loading', network: true };
      var p;
      try { p = c.rpc(fn, args || {}); } catch(e){ return { ok: false, reason: 'network', network: true }; }
      return Promise.resolve(p).then(function(res){
        if(res && res.error){
          if(isMissing(res.error, fn)){ setMode('legacy'); return { ok: false, missing: true, reason: 'not_ready' }; }
          /* A coded refusal came from an installed door. No code means the
             request never reached PostgREST, which proves nothing. */
          if(res.error.code) setMode('live');
          return { ok: false, reason: String(res.error.code || 'network'), network: !res.error.code, error: res.error };
        }
        setMode('live');
        var d = res ? res.data : null;
        if(Array.isArray(d)) d = d[0] || null;
        if(!d || typeof d !== 'object') return { ok: false, reason: 'empty', data: d };
        if(d.ok === false) return { ok: false, reason: String(d.reason || 'refused'), data: d };
        return { ok: true, data: d };
      }, function(){ return { ok: false, reason: 'network', network: true }; });
    });
  }

  /* ---------- the probe ---------- */
  var probePromise = null;
  function probe(){
    if(probePromise) return probePromise;
    var cr = creds();
    probePromise = call('hoh_hall_hearts_list', { p_email: cr.ok ? cr.email : null, p_pin: cr.ok ? cr.pin : null }).then(function(r){
      if(r && r.ok && cr.ok && cr.email === creds().email) takeFavourites(r.data, cr.email);
      if(r && r.network){ probePromise = null; }
      return mode;
    });
    return probePromise;
  }
  /* Resolve to the mode, waiting for the first answer at most `ms`. */
  function ready(ms){
    if(mode !== 'unknown') return Promise.resolve(mode);
    var p = probe();
    if(!ms) return p;
    return Promise.race([p, new Promise(function(r){ setTimeout(function(){ r(mode); }, ms); })]);
  }

  /* ---------- favourites ---------- */
  var favs = {}, favsAccount = '', favsLoaded = false, favLoadPromise = null;
  function takeFavourites(d, account){
    favs = {};
    var ids = (d && Array.isArray(d.ids)) ? d.ids : [];
    ids.forEach(function(id){ if(id != null) favs[String(id)] = 1; });
    favsAccount = account;
    favsLoaded = true;
    emit('hoh:favourites-changed', { ids: Object.keys(favs), loaded: true });
  }
  function loadFavourites(force){
    var cr = creds();
    if(!cr.ok){ favs = {}; favsLoaded = false; favsAccount = ''; return Promise.resolve([]); }
    if(!force && favsLoaded && favsAccount === cr.email) return Promise.resolve(Object.keys(favs));
    if(favLoadPromise && !force) return favLoadPromise;
    favLoadPromise = call('hoh_hall_hearts_list', { p_email: cr.email, p_pin: cr.pin }).then(function(r){
      favLoadPromise = null;
      if(r.ok && creds().email === cr.email) takeFavourites(r.data, cr.email);
      return Object.keys(favs);
    });
    return favLoadPromise;
  }
  function isFavourite(id){
    if(id == null) return false;
    if(favsAccount && favsAccount !== creds().email) return false;
    return !!favs[String(id)];
  }
  var favBusy = {};
  function setFavourite(id, on){
    var cr = creds();
    if(!cr.ok) return Promise.resolve({ ok: false, reason: 'sign_in_required' });
    id = String(id);
    if(favBusy[id]) return favBusy[id];
    var before = !!favs[id];
    if(on) favs[id] = 1; else delete favs[id];
    favsAccount = cr.email;
    emit('hoh:favourites-changed', { id: id, on: !!on, optimistic: true });
    favBusy[id] = call('hoh_hall_heart_set', { p_email: cr.email, p_pin: cr.pin, p_character_id: id, p_on: !!on }).then(function(r){
      delete favBusy[id];
      if(r.ok){
        var now = (r.data && typeof r.data.hearted === 'boolean') ? r.data.hearted : !!on;
        if(now) favs[id] = 1; else delete favs[id];
        emit('hoh:favourites-changed', { id: id, on: now });
        return { ok: true, hearted: now };
      }
      if(before) favs[id] = 1; else delete favs[id];
      emit('hoh:favourites-changed', { id: id, on: before, reverted: true });
      return { ok: false, reason: r.reason, missing: !!r.missing };
    });
    return favBusy[id];
  }

  /* ---------- daily tickets ---------- */
  var tk = { account: '', loaded: false, pool: 0, day: '', next_at: '', heroes: {}, at: 0 };
  var tkLoadPromise = null;
  function takeTicketState(d, account){
    tk.account = account; tk.loaded = true; tk.at = Date.now();
    tk.pool = Math.max(0, (d && d.pool) | 0);
    tk.day = (d && d.day) ? String(d.day) : ptDay();
    tk.next_at = (d && d.next_at) ? String(d.next_at) : '';
    tk.heroes = {};
    ((d && Array.isArray(d.heroes)) ? d.heroes : []).forEach(function(h){
      if(h && h.id != null) tk.heroes[String(h.id)] = { tickets: Math.max(0, h.tickets | 0), applied_today: !!h.applied_today };
    });
    emit('hoh:hall-tickets-changed', { state: ticketCached() });
  }
  function ticketCached(){
    if(!tk.loaded || tk.account !== creds().email) return null;
    /* the day turned while the page stayed open: nothing is applied today */
    if(tk.day && tk.day !== ptDay()){
      Object.keys(tk.heroes).forEach(function(k){ tk.heroes[k].applied_today = false; });
      tk.day = ptDay();
    }
    return tk;
  }
  function ticketState(force){
    var cr = creds();
    if(!cr.ok) return Promise.resolve(null);
    if(!force && ticketCached() && (Date.now() - tk.at) < 60000) return Promise.resolve(tk);
    if(tkLoadPromise && !force) return tkLoadPromise;
    tkLoadPromise = call('hoh_hall_ticket_state', { p_email: cr.email, p_pin: cr.pin }).then(function(r){
      tkLoadPromise = null;
      if(r.ok && creds().email === cr.email){ takeTicketState(r.data, cr.email); return tk; }
      return ticketCached();
    });
    return tkLoadPromise;
  }
  var tkBusy = {};
  function ticketApply(id){
    var cr = creds();
    if(!cr.ok) return Promise.resolve({ ok: false, reason: 'sign_in_required' });
    id = String(id);
    if(tkBusy[id]) return tkBusy[id];
    tkBusy[id] = call('hoh_hall_ticket_apply', { p_email: cr.email, p_pin: cr.pin, p_character_id: id }).then(function(r){
      delete tkBusy[id];
      var d = r.data || {};
      if(r.ok || (d && (d.applied_today || d.next_at))){
        if(tk.account !== cr.email){ tk = { account: cr.email, loaded: true, pool: 0, day: ptDay(), next_at: '', heroes: {}, at: Date.now() }; }
        var h = tk.heroes[id] || { tickets: 0, applied_today: false };
        if(d.tickets != null) h.tickets = Math.max(0, d.tickets | 0);
        if(r.ok || d.applied_today) h.applied_today = true;
        tk.heroes[id] = h;
        if(d.pool != null) tk.pool = Math.max(0, d.pool | 0);
        if(d.next_at) tk.next_at = String(d.next_at);
        tk.day = ptDay();
        emit('hoh:hall-tickets-changed', { id: id, state: tk, applied: !!r.ok });
      }
      return { ok: !!r.ok, reason: r.reason || '', missing: !!r.missing, network: !!r.network,
        tickets: d.tickets, pool: d.pool, chance: d.chance, applied_today: !!(d.applied_today || r.ok), next_at: d.next_at || tk.next_at || '' };
    });
    return tkBusy[id];
  }

  /* ---------- Explore the Hall ---------- */
  var xp = { account: '', loaded: false, seen: {}, today: 0, limit: 20, done_today: false, entry_granted_today: false, day: '' };
  var xpLoadPromise = null;
  function xpCacheKey(account){ return 'hoh-r793-explore:' + encodeURIComponent(account || 'guest'); }
  function xpSaveCache(){
    try {
      localStorage.setItem(xpCacheKey(xp.account), JSON.stringify({ day: xp.day, today: xp.today, limit: xp.limit, done: xp.done_today, entry: xp.entry_granted_today }));
    } catch(_){}
  }
  /* The small per-day snapshot the pre-paint script and the first paint
     read, so the event row does not pop in or out after the page shows. */
  function exploreSnapshot(){
    var account = accountKey();
    try {
      var s = JSON.parse(localStorage.getItem(xpCacheKey(account)) || 'null');
      if(s && s.day === ptDay()) return s;
    } catch(_){}
    return null;
  }
  function takeExploreState(d, account){
    xp.account = account; xp.loaded = true; xp.day = ptDay();
    xp.seen = {};
    ((d && Array.isArray(d.seen)) ? d.seen : []).forEach(function(id){ if(id != null) xp.seen[String(id)] = 1; });
    xp.today = Math.max(0, (d && d.today) | 0);
    xp.limit = Math.max(1, ((d && d.limit) | 0) || 20);
    xp.done_today = !!(d && d.done_today);
    xp.entry_granted_today = !!(d && d.entry_granted_today);
    xpSaveCache();
    emit('hoh:explore-state', { state: xp });
  }
  function exploreCached(){ return (xp.loaded && xp.account === creds().email && xp.day === ptDay()) ? xp : null; }
  function exploreState(force){
    var cr = creds();
    if(!cr.ok) return Promise.resolve(null);
    if(!force && exploreCached()) return Promise.resolve(xp);
    if(xpLoadPromise && !force) return xpLoadPromise;
    xpLoadPromise = call('hoh_hall_explore_state', { p_email: cr.email, p_pin: cr.pin }).then(function(r){
      xpLoadPromise = null;
      if(r.ok && creds().email === cr.email){ takeExploreState(r.data, cr.email); return xp; }
      return r.missing ? null : exploreCached();
    });
    return xpLoadPromise;
  }
  var xpBusy = null;
  function exploreMark(id){
    var cr = creds();
    if(!cr.ok) return Promise.resolve({ ok: false, reason: 'sign_in_required' });
    if(xpBusy) return xpBusy.then(function(){ return exploreMark(id); });
    id = String(id);
    xpBusy = call('hoh_hall_explore_mark', { p_email: cr.email, p_pin: cr.pin, p_character_id: id }).then(function(r){
      xpBusy = null;
      var d = r.data || {};
      if(xp.account !== cr.email){ xp = { account: cr.email, loaded: false, seen: {}, today: 0, limit: 20, done_today: false, entry_granted_today: false, day: ptDay() }; }
      /* a refusal for a hero already seen still teaches us that it was seen */
      if(r.ok || /seen/i.test(r.reason || '')) xp.seen[id] = 1;
      if(d.today != null) xp.today = Math.max(0, d.today | 0);
      if(d.done_today != null) xp.done_today = !!d.done_today;
      if(d.entry_granted) xp.entry_granted_today = true;
      xp.day = ptDay();
      xpSaveCache();
      emit('hoh:explore-state', { state: xp, marked: r.ok ? id : null });
      return { ok: !!r.ok, reason: r.reason || '', missing: !!r.missing, network: !!r.network,
        today: xp.today, done_today: xp.done_today, entry_granted: !!d.entry_granted };
    });
    return xpBusy;
  }

  /* ---------- small shared formatters ---------- */
  /* A win chance (0 to 1) as a percent, with enough decimals that `from`
     and `to` read differently, so a count-up always has somewhere to go. */
  function chanceDecimals(from, to){
    var a = Math.max(0, Number(from) || 0) * 100, b = Math.max(0, Number(to) || 0) * 100;
    var d = (Math.max(a, b) < 1) ? 2 : 1;
    while(d < 3 && a !== b && a.toFixed(d) === b.toFixed(d)) d++;
    return d;
  }
  function formatChance(p, decimals){
    var pct = Math.max(0, Number(p) || 0) * 100;
    var d = (decimals == null) ? (pct < 1 ? 2 : 1) : decimals;
    return pct.toFixed(d) + '%';
  }
  /* "Come back tomorrow at 3:00 AM" / "Come back at 9:00 AM today", in the
     viewer's own clock. Falls back to the next Pacific midnight. */
  function nextAt(iso){
    var t = iso ? new Date(iso) : null;
    if(!t || isNaN(t.getTime())){
      /* the next Pacific midnight, found by stepping forward an hour at a time */
      var now = Date.now(), today = ptDay(new Date(now));
      t = new Date(now);
      for(var i = 1; i <= 26; i++){
        var probeAt = new Date(now + i * 3600 * 1000);
        if(ptDay(probeAt) !== today){ t = new Date(probeAt.getTime() - (probeAt.getMinutes() * 60000) - probeAt.getSeconds() * 1000); break; }
      }
    }
    return t;
  }
  function comeBackText(iso){
    var t = nextAt(iso);
    var time = '';
    try { time = t.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); } catch(_){ time = t.getHours() + ':' + ('0' + t.getMinutes()).slice(-2); }
    var now = new Date();
    var sameDay = t.getFullYear() === now.getFullYear() && t.getMonth() === now.getMonth() && t.getDate() === now.getDate();
    return sameDay ? 'Come back at ' + time + ' today.' : 'Come back tomorrow at ' + time + '.';
  }

  function resetForAccount(){
    favs = {}; favsLoaded = false; favsAccount = ''; favLoadPromise = null;
    tk = { account: '', loaded: false, pool: 0, day: '', next_at: '', heroes: {}, at: 0 }; tkLoadPromise = null;
    xp = { account: '', loaded: false, seen: {}, today: 0, limit: 20, done_today: false, entry_granted_today: false, day: '' }; xpLoadPromise = null;
    emit('hoh:favourites-changed', { ids: [], reset: true });
    if(mode === 'live' && creds().ok){ loadFavourites(true); }
  }
  try {
    document.addEventListener('hoh:signed-in', resetForAccount);
    document.addEventListener('hoh:signed-out', resetForAccount);
  } catch(_){}

  /* Ask once, as soon as the Hall's client exists. DOMContentLoaded is
     after every deferred script has run, so the section's loader has
     started; waitClient covers the roster fetch that creates the client. */
  function boot(){
    probe().then(function(m){ if(m === 'live' && creds().ok) loadFavourites(); });
  }
  try {
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else setTimeout(boot, 0);
  } catch(_){}

  window.HOHHallDoors = {
    mode: function(){ return mode; },
    isLive: function(){ return mode === 'live'; },
    ready: ready,
    probe: probe,
    creds: function(){ var c = creds(); return { email: c.email, ok: c.ok }; },
    ptDay: ptDay,
    isMissing: isMissing,
    favourites: { load: loadFavourites, has: isFavourite, set: setFavourite,
      ids: function(){ return (favsAccount && favsAccount === creds().email) ? Object.keys(favs) : []; },
      loaded: function(){ return favsLoaded && favsAccount === creds().email; } },
    tickets: { state: ticketState, apply: ticketApply, cached: ticketCached,
      hero: function(id){ var c = ticketCached(); return (c && id != null) ? (c.heroes[String(id)] || null) : null; } },
    explore: { state: exploreState, mark: exploreMark, cached: exploreCached, snapshot: exploreSnapshot },
    chanceDecimals: chanceDecimals,
    formatChance: formatChance,
    comeBackText: comeBackText
  };
  window.hohR793Live = function(){ return mode === 'live'; };
})();
